
import { useEffect } from "react"
import { Badge, FormControl, Modal } from "react-bootstrap"
import { formSuccessRedirect } from "../../app/actions"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import creationApi from "../../app/services/secured/creation"
import { isModalOpened, modalClose, ModalTypes } from "../../app/slice/modal"
import Urls from "../../assets/js/Urls"
import { IfTrue } from "../misc/Blocks"
import { LoadingButton } from "../misc/Buttons"
import SimpleForm from "../misc/SimpleForm"
import ModalCloseButton from "../Modals/ModalCloseButton"
import LandingInfo from "./Forms/LandingInfo"

const ModalNewLanding = () => {
    const dispatch = useAppDispatch();
    const isOpened = useAppSelector(isModalOpened(ModalTypes.NewLanding));
    const [createLanding, createLandingRes] = creationApi.useCreateLandingMutation();

    dispatch(formSuccessRedirect({
        redirectUrl: createLandingRes.data && Urls.landing.edit(createLandingRes.data.id as number), 
        data: createLandingRes,
        message: "Succès création landing page. Vous avez été redirigé vers l'édition."
    }));
    useEffect(() => {
        if (createLandingRes.isSuccess) dispatch(modalClose());
    }, [createLandingRes.isSuccess])
    return <IfTrue condition={isOpened}>
        <SimpleForm onSubmit={(json) => createLanding(json)}>
            <Modal.Header>
                <h3 className='m-0'>Création Landing Page <Badge bg='primary'>V1</Badge></h3>
            </Modal.Header>
            <Modal.Body>
                <LandingInfo />
            </Modal.Body>
            <Modal.Footer>
                <ModalCloseButton />
                <LoadingButton data={createLandingRes}>Créer</LoadingButton>
            </Modal.Footer>
        </SimpleForm>
    </IfTrue>
}

export default ModalNewLanding;